import { Injectable, inject } from "@angular/core";
import { ModalService } from "src/shared/modal";
import { PasswordFormComponent } from "./password-form.component";

@Injectable()
export class PasswordFormService {
  private readonly modal = inject(ModalService)


  showChangePassword() {
    return this.modal.openDialog<PasswordFormComponent, void, void>(PasswordFormComponent).toPromise()
  }
}
